import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import { User } from '@/interfaces/user'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import AuthFilter from '@/mixins/auth-filter'
import { createUser, updateUser, deleteUser } from './gql'
import { TypedGqlError } from '@/interfaces/error'

@Component({
  components: {
    AppTextField,
    AppSelector
  }
})
export default class ManagerDialog extends mixins(AuthFilter) {
  disableConfirm = false

  superiorManagerOptions: string[] = []

  deleteDialog = {
    show: false,
    title: '删除',
    text: '确定要删除该管理员？'
  }

  targetManager: User | null = null

  newManagerDialog = {
    show: false,
    disable: false
  }

  managerInput: {
    [key: string]: any;
  } = {
    type: 'new',
    username: '',
    phone: '',
    password: '',
    roleIndex: -1
  }

  managerTypes: {
    [key: string]: any;
  } = {
    ADMIN: '系统管理员',
    ROOT: '超级管理员'
  }

  managerTypeOptions = ['系统管理员', '超级管理员']
  managerTypeCodes = ['ADMIN', 'ROOT']

  editHandler (e: Event, user: User) {
    e.preventDefault()
    e.stopPropagation()
    this.targetManager = user

    const roleIndex = this.managerTypeCodes.findIndex((code: string) => {
      return code === user.role
    })

    this.managerInput = {
      type: 'edit',
      username: user.username,
      phone: user.phone,
      roleIndex
    }
    this.newManagerDialog.show = true
  }

  deleteHandler (e: Event, manager: User) {
    e.preventDefault()
    e.stopPropagation()
    this.targetManager = manager
    this.deleteDialog.text = `是否确定删除管理员 “${manager.username}” ?`
    this.deleteDialog.show = true
  }

  async newManagerConfirm () {
    const { username, phone, password, roleIndex } = this.managerInput

    const newManagerValid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
    if (!newManagerValid) {
      return
    }

    this.newManagerDialog.show = false
    this.newManagerDialog.disable = true

    try {
      await this.$apollo.mutate({
        mutation: createUser,
        variables: {
          input: {
            username,
            password,
            phone,
            role: this.managerTypeCodes[roleIndex] || null
          }
        }
      })
      showNotification({
        msg: '管理员添加成功',
        type: SnackType.Success
      })
      this.clearNewManager()
      this.newManagerDialog.disable = false
    } catch (e) {
      this.newManagerDialog.disable = false
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async editManagerConfirm () {
    const { roleIndex, type, ...rest } = this.managerInput
    const targetManager = this.targetManager as Record<string, any>

    const newManagerValid = (this.$refs.form as Vue & { validate: () => boolean }).validate()
    if (!newManagerValid || !targetManager || type !== 'edit') {
      return
    }

    const managerId = Number(targetManager.id)

    const input: Record<string, any> = {}

    for (const key in rest) {
      if (rest[key] !== targetManager[key]) {
        input[key] = rest[key]
      }
    }

    const role = this.managerTypeCodes[roleIndex]
    input.role = role

    this.newManagerDialog.show = false

    try {
      await this.$apollo.mutate({
        mutation: updateUser,
        variables: {
          input,
          userId: managerId
        }
      })
      showNotification({
        msg: '管理员修改成功',
        type: SnackType.Success
      })
      this.clearNewManager()
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async deleteManagerConfirm () {
    const { id } = this.targetManager as User

    this.deleteDialog.show = false

    try {
      await this.$apollo.mutate({
        mutation: deleteUser,
        variables: {
          userId: +id
        }
      })
      showNotification({
        msg: '管理员删除成功',
        type: SnackType.Success
      })
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  clearNewManager () {
    this.managerInput = {
      type: 'new',
      username: '',
      phone: '',
      password: '',
      roleIndex: -1
    }
  }
}
